import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {

  year: string;
  showScrollToTop: boolean = false;

  constructor() { }

  ngOnInit() {
    this.year = this.getYear().toString();
    window.addEventListener('scroll', this.onScroll, true);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
  }


  getYear() {
    return new Date().getFullYear();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  
  onScroll = () => {
    this.showScrollToTop = window.scrollY > 0;
  };

}
